import React from "react"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import CaseBox from "../components/caseBox"
import Splash from "../components/splash"
import HalfBlocks from "../components/halfBlocks"

const AboutTemplate = ({ images, options, children }) => (
  <Layout>
    <SEO title={`About | ${options.title}`} />
    <Splash subtitle="About" title={`${options.title}`}>
      <Img style={{ minHeight: "150px" }} fluid={images[images.length - 1]} />
    </Splash>
    <CaseBox>
      {options.summary && (
        <section>
          <div className="summary">
            <p>{options.summary.text}</p>
          </div>
        </section>
      )}
      <HalfBlocks blocks={renderBlocks(options.body, images)} />
      {children}
    </CaseBox>
  </Layout>
)

const renderBlocks = (body, images) => {
  return body.map((b, i) => ({
    ...b,
    img: images && images[i] ? images[i] : undefined,
  }))
}

export default AboutTemplate
